import { render, staticRenderFns } from "./backstage.vue?vue&type=template&id=316a485a&scoped=true"
import script from "./backstage.vue?vue&type=script&lang=js"
export * from "./backstage.vue?vue&type=script&lang=js"
import style0 from "./backstage.vue?vue&type=style&index=0&id=316a485a&prod&lang=scss"
import style1 from "./backstage.vue?vue&type=style&index=1&id=316a485a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a485a",
  null
  
)

export default component.exports